module.exports = __webpack_public_path__ + "img/80.general_cleaning.dc16d4c4.svg";